import React from 'react'
import { useSelector } from 'react-redux'

import { Box, Center, Flex, Image } from '@chakra-ui/react'
import { Scrollbars } from 'react-custom-scrollbars-2'

import { ConfigType } from '@/features/configs/config.constant'
import useConfig from '@/features/configs/useConfig'
import useFile from '@/features/files/useFile'
import { authSelector } from '@/stores/auth/authSlice'
import { useTranslation } from 'react-i18next'
import { FaEdit } from 'react-icons/fa'
import SidebarSection from './components/SidebarSection'
import config, { APP_MODE } from '@/config'

const Sidebar = ({ show = true }) => {
  const { user } = useSelector(authSelector)
  const { t } = useTranslation()
  const isProduction = config.mode == APP_MODE.PRODUCTION

  const { useDownloadFile } = useFile()
  const downloadFile = useDownloadFile()

  const { useFetchConfigByType } = useConfig()
  const { data: fetchUserManualResponse } = useFetchConfigByType(ConfigType.EXTERNAL_USER_MANUAL)
  const sidebarData = [
    {
      title: t('SIDE_BAR_VENDOR'),
      defaultOpen: true,
      links: [
        {
          name: t('SIDE_BAR_VENDOR_QUOTATION'),
          path: isProduction ? '/RFQs' : '/external/RFQs',
          target: '_parent',
          icon: <FaEdit />,
        },
        {
          name: t('SIDE_BAR_VENDOR_USER_MANUAL'),
          icon: <FaEdit />,
          handleLinkClick: () => showUserManual(),
        },
      ],
    },
  ]

  const showUserManual = async () => {
    if (!fetchUserManualResponse?.mainValue) {
      return
    }
    const response = await downloadFile.mutateAsync(fetchUserManualResponse?.mainValue)

    const blob = new Blob([response.data], { type: response.headers['content-type'] })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.target = '_blank'
    a.click()
    window.URL.revokeObjectURL(url)
  }

  return (
    <Flex w="256px" bg="teal.500" color="white" direction="column" display={[show ? 'block' : 'none']} height="100%">
      <Center height={'5%'} bg="rgba(0,0,21,.2)" minH="40px">
        <Image w="100px" objectFit="cover" src="https://images.sw.cdn.siemens.com/logo/logo-white.svg" />
      </Center>
      <Box height={'95%'}>
        <Scrollbars autoHide>
          <Flex p={2} direction="column" gap="2">
            {sidebarData.map((row) => {
              return <SidebarSection key={row.title} {...row} />
            })}
          </Flex>
        </Scrollbars>
      </Box>
    </Flex>
  )
}

export default Sidebar
